import { useState } from 'react';
import { urlApi } from '../helpers/functionHelpers';

const useEmail = () => {
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const sendEmail = async ({to, subject, html, bcc}) => {
    setIsSending(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch(`${urlApi}/api/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ to, subject, html, bcc }),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.message || 'Error al enviar el correo');
      }
    } catch (err) {
      setError(err.message || 'Error de conexión');
    } finally {
      setIsSending(false);
    }
  };

  return {
    sendEmail,
    isSending,
    error,
    success,
  };
};

export default useEmail;